<script setup lang="ts">
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface Props {
    open: boolean;
    title?: string;
    description?: string;
    cancelText?: string;
    confirmText?: string;
    variant?: 'default' | 'destructive';
    loading?: boolean;
}

withDefaults(defineProps<Props>(), {
    title: 'Êtes-vous sûr ?',
    description: 'Cette action est irréversible.',
    cancelText: 'Annuler',
    confirmText: 'Confirmer',
    variant: 'destructive',
    loading: false,
});

const emit = defineEmits<{
    'update:open': [value: boolean];
    confirm: [];
    cancel: [];
}>();

const handleConfirm = () => {
    emit('confirm');
};

const handleCancel = () => {
    emit('cancel');
    emit('update:open', false);
};
</script>

<template>
    <AlertDialog :open="open" @update:open="$emit('update:open', $event)">
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{{ title }}</AlertDialogTitle>
                <AlertDialogDescription>
                    {{ description }}
                </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel @click="handleCancel" :disabled="loading">
                    {{ cancelText }}
                </AlertDialogCancel>
                <AlertDialogAction as-child>
                    <Button :variant="variant" @click="handleConfirm">
                        <template v-if="loading">
                            <!-- Un spinner simple ici si nécessaire -->
                        </template>
                        {{ confirmText }}
                    </Button>
                </AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
